import { getFundPerformance } from '../../api/fund.api';
import { FundPerformanceData } from '../../types/fundsummary.type';
import useFundResource, { FundResourceResult } from './useFundResource';

const useFundPerformance = (
  ric: string = '',
  token: string = '',
  saleInCountryCode: string = 'US',
): FundResourceResult<FundPerformanceData> =>
  useFundResource<FundPerformanceData>(
    getFundPerformance,
    ric,
    token,
    saleInCountryCode,
  );

export default useFundPerformance;
